import _ from 'lodash'
import { useSlideStore } from '~/store/slide'
import { useWishStore } from '~/store/wish'
import { useTemplateStore } from '~/store/template'
import { usePreweddingStore } from '~/store/prewedding'
import { useSettingControlStore } from '~/store/settingControl'

export const useSlideModeACustom = () => {
  const slideStore = useSlideStore()
  const wishStore = useWishStore()
  const templateStore = useTemplateStore()
  const preweddingStore = usePreweddingStore()
  const settingControl = useSettingControlStore()

  
  const distanceCount = ref(0)
  const runningWishCount = ref(9999) // เอาไว้เช็คให้เล่นรูปติดกัน
  
  const localPlayedHolder = ref({} as any)
  const localPlayed = ref({}  as any)

  const slideCustom = computed(() => settingControl?.slideCustom)

  // const validImages = computed(() => _.filter(wishStore.allWishDatabase, w => !localPlayedHolder.value[w.docId] && localPlayed.value[w.docId] < slideCustom.value?.limit))


  function main() {
    slideStore.showIndexAndLimit = false
    checkAndResetPlayed()
    
    generateAndFillQueue()
    
    let newWishList = wishStore.getNewDocIdList()
    const docId = newWishList?.length > 0 ? newWishList[0] : wishStore.queue[0] // ไม่ใช้ wishStore.queue.shift() เพราะแค่จะเอา wishId
    const wishData = wishStore.getWishDataById(docId)
    const isAllow = getAllowDistanceImage()
    
    if(wishData && isAllow) {
      distanceCount.value = 0
      runningWishCount.value++
      slideStore.view = 'wish'
      updateLocalPlayWish(wishData)

      if(newWishList?.length > 0) {
        wishStore.newWishes.shift();
      } else {
        wishStore.queue.shift()
      }

      return {
        type: 'wish',
        data: wishData
      }
    }

    slideStore.view = 'prewedding'
    distanceCount.value++

    if(distanceCount.value >= slideCustom.value?.offset) {
      runningWishCount.value = 0 
    }

    return {
      type: 'prewedding',
      data: preweddingStore.queue.shift()
    }
  }

  function generateAndFillQueue() {
    const settingStore = useSettingControlStore()
    const slideCustom = settingStore?.slideCustom || {
      active: true,
      offset: 2,
      limit: 1,
      option:2,
    }

    const filtered:any = _.filter(wishStore.allWishDatabase, w => {
      // ถ้ายังไม่เคยเล่น
      if(!localPlayed.value[w.docId]) {
        return w
      }

      //ถ้ามีการเล่นไปแล้ว และ ไม่เกินลิมิต
      if(!localPlayedHolder.value[w.docId] && localPlayed.value[w.docId] && localPlayed.value[w.docId] < slideCustom.limit) {
        return w
      }
    })

    const uniqList = _.uniqBy(filtered, 'docId')
    let ids = _.map(uniqList, 'docId')


    // ---- shuffle queue ----
    ids = _.shuffle(ids)
    // -----------------------

    wishStore.queue = ids
  }

  function getAllowDistanceImage() {
    const offsetLimit = slideCustom.value?.offset // ระยะห่างกันกี่รูป (prewedding คั่น)
    const amount = slideCustom.value?.option // เล่นติดกันกี่รูป (wish)

    // เมื่อมีคำอวยพรใหม่เข้ามา => เช้คถ้าน้อยกว่าจำนวนให้เล่นติดกัน  และ queue มี 1 รูป  ให้เล่นทั้งหมด
    if (
      runningWishCount.value < amount && 
      wishStore.queue?.length === 1 && 
      wishStore.getNewDocIdList()?.length > 0
    ) {
      runningWishCount.value = amount
      return true
    }

    if(runningWishCount.value < amount) {
      return true
    }

    if(distanceCount.value < offsetLimit) {
      return false
    }

    return true
  }

  function updateLocalPlayWish(wishData) {
    if(_.has(localPlayed.value, wishData.docId)) {
      localPlayed.value[wishData.docId]++
    } else {
      localPlayed.value[wishData.docId] = 1
    }

    localPlayedHolder.value[wishData.docId] = true
  }

  function checkAndResetPlayed() {

    // play: infinity
    if(slideCustom.value?.limit === 0 && wishStore.queue?.length === 0) {
      localPlayed.value = {}
    }

    // play: limit
    if(slideCustom.value?.limit > 1 && wishStore.queue?.length === 0) {
      localPlayedHolder.value = {}
    }
  }



  return {
    main
  }

}


  // function fillQueue() {
  //   if (!validImages.value.length) return;

  //   const list:any = _.cloneDeep(wishStore.queue)
  
  //   while (wishStore.queue.length < slideCustom.value?.limit) {
  //     // Prioritize new images
  //     const newImages = _.filter(validImages.value, w => !localPlayed.value[w.docId] && !localPlayedHolder.value[w.docId] && _.includes(wishStore.queue, w.docId));
  
  //     let candidates = [];
  //     if (newImages.length) {
  //       candidates = newImages;
  //     } else {
  //       candidates = validImages.value.filter(img => !wishStore.queue.includes(img));
  //     }
  
  //     if (!candidates.length) break;
  
  //     // Shuffle
  //     const shuffled = [...candidates].sort(() => Math.random() - 0.5);
  //     const chosen = shuffled[0];
  
  //     if (chosen) {
  //       list.push(chosen);
  //     } else {
  //       break;
  //     }
  //   }


  //   console.log(list)
  //   wishStore.queue = list
  // }